import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player/soundcloud';
import './SoundcloudPlayer.css';

const soundcloudTracks = [
    { id: 1, title: 'Simplistic House - August 2021', url: 'https://soundcloud.com/simplisticmusic/simplistic-house-august-2021' },
    { id: 2, title: 'Simplistic House - January 2021', url: 'https://soundcloud.com/simplisticmusic/simplistic-house-january-2021' },
    { id: 3, title: 'Luke Fair - Live at Desert In Me', url: 'https://soundcloud.com/desertinme/desert-in-podcast-02-luke-fair-live-090219' },
    { id: 4, title: 'Vicious X Cycle - Rock the Funky Beats', url: 'https://soundcloud.com/viciousxcycle/rock-the-funky-beats' },
    { id: 5, title: 'Bamborghini - Back to Our Regularly Scheduled Programming', url: 'https://soundcloud.com/bamborghini/back-to-our-regularly-scheduled-programming-2024-08-23' },
];

function SoundcloudPlayer({ isActive, onPlay, onPause, isPlaying }: { isActive: boolean, onPlay: () => void, onPause: () => void, isPlaying: boolean }) {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
    const playerRef = useRef<ReactPlayer>(null);

    useEffect(() => {
        if (isActive && !isPlaying) {
            playerRef.current?.seekTo(0); // Reset to beginning
        }
    }, [isActive, isPlaying]);

    const handleTrackChange = (index: number) => {
        setCurrentTrackIndex(index);
        if (isActive) {
            playerRef.current?.seekTo(0); // Reset to beginning when changing track
        }

        if (!isPlaying) {
          onPlay(); // Start playing when track is changed
        }
    };

    const handlePlay = () => {
        onPlay();
    };

    const handlePause = () => {
        onPause();
    };


    return (
         <div className="player">
      <div className="player-container">
      <ReactPlayer
                ref={playerRef}
                url={soundcloudTracks[currentTrackIndex].url}
                playing={isActive && isPlaying}
                controls={true}
                width="100%"
                height="100%"
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={() => {
                    if (currentTrackIndex < soundcloudTracks.length - 1) {
                        handleTrackChange(currentTrackIndex + 1);
                    } else {
                        onPause();
                    }
                }}
            />
      </div>
      <div className="track-list-container">
      <ul className="track-list">
        {soundcloudTracks.map((track, index) => (
          <li className="track-row" key={track.id} onClick={() => handleTrackChange(index)}>
          <div className="track-number">{index + 1}</div>
          <div className="track-info">
            <div className="track-artist">{track.title}</div>
            <div className="track-title">{track.title}</div>
          </div>
          <div className="track-actions">
            <i className="fa fa-play play-icon"></i> {/* Use a Font Awesome icon */}
          </div>
        </li>
        ))}
      </ul>
      </div>
    </div>
    );
}

export default SoundcloudPlayer;